import { memo, SVGProps } from 'react';
import React from 'react';

const VectorIcon1 = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 370 392' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M174.313 343.351C133.016 328.6 154.749 261.587 132.043 224.071C115.504 196.744 71.5106 192.683 64.2906 161.567C55.3077 122.855 59.9161 74.0621 91.6997 50.2049C123.257 26.5172 166.448 49.5748 205.442 55.6172C241.407 61.1903 283.354 55.5963 306.695 83.5205C330.22 111.665 323.452 152.809 316.84 188.89C310.825 221.709 294.415 249.466 271.788 273.987C243.675 304.455 213.353 357.296 174.313 343.351Z'
      fill='#64AB0A'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M225.004 293.532C215.443 282.313 211.614 267.817 211.85 253.079C212.082 238.614 215.828 223.904 226.281 213.904C236.548 204.082 251.248 201.831 265.457 201.797C279.709 201.762 294.707 203.672 304.823 213.713C314.967 223.78 319.216 238.941 317.127 253.079C315.26 265.712 302.793 272.442 294.687 282.309C284.88 294.248 280.71 313.52 265.457 315.977C249.63 318.526 235.403 305.733 225.004 293.532Z'
      fill='#82C52D'
    />
  </svg>
);
const Memo = memo(VectorIcon1);
export { Memo as VectorIcon1 };
